// Function to scroll image upward when card animate on scroll.

(function aos($, Drupal) {
  Drupal.behaviors.aosImage = {
    attach() {
      $('.aos-animate picture img').addClass('aosimage');
    },
  };

  Drupal.behaviors.toggleExtraContent = {
    attach: function (context, settings) {
      once('toggle-extra-init', '.toggle-btn', context).forEach((toggleBtn) => {
        toggleBtn.addEventListener('click', () => {
          const card = toggleBtn.closest('.statistics-content');
          const content = card.querySelector('.content-designation');
          const arrow = card.querySelector('.arrow-icon');

          // Close all other open cards
          document.querySelectorAll('.statistics-content').forEach((otherCard) => {
            if (otherCard !== card) {
              const otherContent = otherCard.querySelector('.content-designation');
              const otherArrow = otherCard.querySelector('.arrow-icon');
              otherContent.classList.remove('full-show');
              otherArrow.classList.remove('show-rotate');
            }
          });

          // Toggle current card
          const isExpanded = content.classList.toggle('full-show');
          arrow.classList.toggle('show-rotate', isExpanded);
        });
      });
    }
  };
})(jQuery, Drupal);
